"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./styles.css");
var _dance = require("../../assets/movement-buttons/dance.svg");
var _kickLeft = require("../../assets/movement-buttons/kick-left.svg");
var _kickRight = require("../../assets/movement-buttons/kick-right.svg");
var _waveLeft = require("../../assets/movement-buttons/wave-left.svg");
var _waveRight = require("../../assets/movement-buttons/wave-right.svg");
var _getReady = require("../../assets/movement-buttons/get-ready.svg");
var _eyes = require("../../assets/movement-buttons/eyes.svg");
var _showOff = require("../../assets/movement-buttons/show-off.svg");
var _RCSequencerManager = _interopRequireDefault(require("../../utils/RCSequencer/RCSequencerManager"));
var _Movement = _interopRequireDefault(require("../../utils/RCSequencer/Movement"));
var _speedContext = _interopRequireDefault(require("../../store/speed-context"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MovementButtons = _ref => {
  let {
    isDeactivated
  } = _ref;
  const speedCtx = (0, _react.useContext)(_speedContext.default);
  const clickMovementHandler = movement => {
    if (isDeactivated) return;
    switch (movement) {
      case "kickLeft":
        _RCSequencerManager.default.addToSequence(new _Movement.default("kick", movement, speedCtx.speed, {
          side: 0
        }));
        break;
      case "kickRight":
        _RCSequencerManager.default.addToSequence(new _Movement.default("kick", movement, speedCtx.speed, {
          side: 1
        }));
        break;
      case "waveLeft":
        _RCSequencerManager.default.addToSequence(new _Movement.default("wave", movement, speedCtx.speed, {
          side: 0
        }));
        break;
      case "waveRight":
        _RCSequencerManager.default.addToSequence(new _Movement.default("wave", movement, speedCtx.speed, {
          side: 1
        }));
        break;
      default:
        // icon and movement names are the same in this case
        _RCSequencerManager.default.addToSequence(new _Movement.default(movement, movement, speedCtx.speed));
        break;
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "movement-buttons-container",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "movement-button-dance movement-button-container ".concat(isDeactivated ? "movement-button-container-deactivated" : ""),
      onClick: () => clickMovementHandler("dance"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dance.ReactComponent, {
        className: "movement-button-svg"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "movement-button-caption",
        children: "Dance!"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "movement-button-kick-left movement-button-container ".concat(isDeactivated ? "movement-button-container-deactivated" : ""),
      onClick: () => clickMovementHandler("kickLeft"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_kickLeft.ReactComponent, {
        className: "movement-button-svg"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "movement-button-caption",
        children: "Kick Left"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "movement-button-kick-right movement-button-container ".concat(isDeactivated ? "movement-button-container-deactivated" : ""),
      onClick: () => clickMovementHandler("kickRight"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_kickRight.ReactComponent, {
        className: "movement-button-svg"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "movement-button-caption",
        children: "Kick Right"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "movement-button-wave-left movement-button-container ".concat(isDeactivated ? "movement-button-container-deactivated" : ""),
      onClick: () => clickMovementHandler("waveLeft"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_waveLeft.ReactComponent, {
        className: "movement-button-svg"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "movement-button-caption",
        children: "Wave Left"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "movement-button-wave-right movement-button-container ".concat(isDeactivated ? "movement-button-container-deactivated" : ""),
      onClick: () => clickMovementHandler("waveRight"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_waveRight.ReactComponent, {
        className: "movement-button-svg"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "movement-button-caption",
        children: "Wave Right"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "movement-button-get-ready movement-button-container ".concat(isDeactivated ? "movement-button-container-deactivated" : ""),
      onClick: () => clickMovementHandler("getReady"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_getReady.ReactComponent, {
        className: "movement-button-svg"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "movement-button-caption",
        children: "Get Ready"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "movement-button-show-off movement-button-container ".concat(isDeactivated ? "movement-button-container-deactivated" : ""),
      onClick: () => clickMovementHandler("showOff"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_showOff.ReactComponent, {
        className: "movement-button-svg"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "movement-button-caption",
        children: "Celebrate"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "movement-button-eyes movement-button-container ".concat(isDeactivated ? "movement-button-container-deactivated" : ""),
      onClick: () => clickMovementHandler("wiggleEyes"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_eyes.ReactComponent, {
        className: "movement-button-svg"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "movement-button-caption",
        children: "Wiggle Eyes"
      })]
    })]
  });
};
var _default = exports.default = MovementButtons;